const TEMPLATE_NAME = 'FEEDBACK';

/**
 * Function to show success Feedback
 * @param {Array} message Message to show in the feedback.
 */
export function showFeedbackSuccess(message) {
  return {
    type: `${TEMPLATE_NAME}_FULFILLED`,
    payload: message
  };
}

/**
 * Function to show failure  Feedback
 * @param {Array} message Message to show in the feedback.
 */
export function showFeedbackFailure(message) {
  return {
    type: `${TEMPLATE_NAME}_REJECTED`,
    payload: message
  };
}

/**
 * Function to clear feedback.
 */
export function clearFeedback() {
  return {
    type: `${TEMPLATE_NAME}_CLEAR`
  };
}
